// extracted by mini-css-extract-plugin
export default {"footer_container":"Footer_footer_container__czylu","logo_container":"Footer_logo_container__MtK-U","content_container":"Footer_content_container__TZ7En"};